import React from 'react';
import { Button, Container, Image, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import './Topbar.css';
import { GroupedRoutes } from '../routes/routes';
import IRouter, { IGroupedRouter } from '../Interface/IRouter';
import Logo from "../../assests/Logo.png"
import { useAllowedPages } from '../../context/AllowedPagesContext';
import Auth from '../Auth/auth';

export default function TopBar() {
  let navigate = useNavigate();
  const location = useLocation();
  const { isPageAllowed, clearAllowedPages } = useAllowedPages();


  const handleLogout = () => {
    Auth.signout();
    clearAllowedPages();
    navigate('/login');
  };

  return (
    <>
      <Navbar bg="dark" variant="dark">
        <Container>
          <Navbar.Brand className="ms-2 fw-bold" style={{ color: 'white' }}>
            {/* <div>
              <Image 
              src={Logo} 
              width={50}
              />
            </div> */}
            Nixauth
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">

            {
              isPageAllowed('dashboard') &&
              <Nav>
                <Nav.Link
                  onClick={() => navigate('/dashboard')}
                  className={location.pathname === '/dashboard' ? 'active-link fw-bold' : 'fw-bold'}
                >
                  Dashboard
                </Nav.Link>
              </Nav>
            }

            {GroupedRoutes.map((data: IGroupedRouter, index: number) => {
              if (!data.navbarShow) return null;
              
              const allowedChildren = data.children.filter((child: IRouter) => 
                child.navbarShow && isPageAllowed(child.path)
              );
              
              if (allowedChildren.length === 0) return null;
              
              if (allowedChildren.length === 1) {
                const singleChild = allowedChildren[0];
                return (
                  <Nav key={index}>
                    <Nav.Link
                      onClick={() => navigate(singleChild.path)}
                      className={location.pathname.includes(singleChild.path) ? 'active-link fw-bold' : 'fw-bold'}
                    >
                      {singleChild.name}
                    </Nav.Link>
                  </Nav>
                );
              }
              
              return (
                <Nav key={index}>
                  <NavDropdown title={data.name} id="basic-nav-dropdown" className="fw-bold" menuVariant="dark">
                    {allowedChildren.map((child: IRouter, idx: number) => (
                      <NavDropdown.Item
                        key={idx}
                        onClick={() => navigate(child.path)}
                        className={location.pathname.includes(child.path) ? 'active-link fw-bold' : ''}
                      >
                        {child.name}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                </Nav>
              );
            })}
          </Navbar.Collapse>

          <div className="d-flex justify-content-end ms-auto">
            <Button className="me-3" size="sm" onClick={handleLogout}>
              Logout
            </Button>
          </div>
        </Container>
      </Navbar>
    </>
  );
}
